<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 商品管理
      </div>
      <div class="contentLeft">
        <div class="con">
          <!-- 搜索栏 + 操作按钮 -->
          <div class="toolbar">
            <el-select v-model="query.categoryId" placeholder="全部分类" clearable style="width: 160px; margin-right: 10px;" @change="onFilterChange">
              <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
            </el-select>
            <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 120px; margin-right: 10px;" @change="onFilterChange">
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="0"></el-option>
            </el-select>
            <el-button class="addBtn" style="color: #fff;" @click="openDialog('add')">新增商品</el-button>
            <el-button @click="openCategoryDialog">分类管理</el-button>
          </div>

          <!-- 商品表格 -->
          <div class="table-con consiliaTable">
            <el-table
              ref="multipleTable"
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="ID" prop="id" width="60"></el-table-column>
              <el-table-column align="center" label="封面" width="80">
                <template #default="{ row }">
                  <img v-if="row.coverImage" :src="resolveImg(row.coverImage)" style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px;" />
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="商品名称" prop="name" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="副标题" prop="subtitle" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="城市代理价" prop="cityAgentPrice" width="110">
                <template #default="{ row }">¥{{ formatPrice(row.cityAgentPrice) }}</template>
              </el-table-column>
              <el-table-column align="center" label="区县代理价" prop="districtAgentPrice" width="110">
                <template #default="{ row }">¥{{ formatPrice(row.districtAgentPrice) }}</template>
              </el-table-column>
              <el-table-column align="center" label="经销商价" prop="dealerPrice" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.dealerPrice) }}</template>
              </el-table-column>
              <el-table-column align="center" label="零售价" prop="retailPrice" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.retailPrice) }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="80">
                <template #default="{ row }">
                  <span :style="{ color: row.status === 1 ? '#67c23a' : '#f56c6c' }">
                    {{ row.status === 1 ? '上架' : '下架' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="排序" prop="sortOrder" width="70"></el-table-column>
              <el-table-column align="center" label="操作" width="140">
                <template #default="{ row }">
                  <span class="editor" @click="openDialog('edit', row)">编辑</span>
                  <span class="del" @click="handleDelete(row)">删除</span>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.pageNum"
                :page-size="query.pageSize"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品新增/编辑弹窗 -->
    <el-dialog
      :title="dialogMode === 'add' ? '新增商品' : '编辑商品'"
      v-model="dialogVisible"
      width="960px"
      top="5vh"
      :close-on-click-modal="false"
      class="product-edit-dialog"
    >
      <el-form ref="productForm" :model="formData" :rules="formRules" label-width="110px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="subtitle">
          <el-input v-model="formData.subtitle" placeholder="商品卖点"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="categoryId">
          <el-select v-model="formData.categoryId" placeholder="选择分类" style="width: 100%;">
            <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面图片" prop="coverImage">
          <image-crop-upload v-model="formData.coverImage" />
        </el-form-item>
        <el-form-item label="城市代理价" prop="cityAgentPrice">
          <el-input-number v-model="formData.cityAgentPrice" :min="0" :precision="2" :step="10" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="区县代理价" prop="districtAgentPrice">
          <el-input-number v-model="formData.districtAgentPrice" :min="0" :precision="2" :step="10" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="经销商价" prop="dealerPrice">
          <el-input-number v-model="formData.dealerPrice" :min="0" :precision="2" :step="10" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="零售价" prop="retailPrice">
          <el-input-number v-model="formData.retailPrice" :min="0" :precision="2" :step="10" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="formData.sortOrder" :min="0" :step="1" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="formData.status" :active-value="1" :inactive-value="0" active-text="上架" inactive-text="下架"></el-switch>
        </el-form-item>
        <el-form-item label="商品详情" prop="detail">
          <rich-editor v-model="formData.detail" :height="380" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>

    <!-- 分类管理弹窗 -->
    <el-dialog title="分类管理" v-model="categoryDialogVisible" width="600px" center>
      <div style="margin-bottom: 12px;">
        <el-button type="primary" size="small" @click="openCategoryForm('add')">新增分类</el-button>
      </div>
      <el-table :data="categoryList" :header-cell-style="{ background: '#f7f7f7', color: '#333' }" v-loading="categoryLoading">
        <el-table-column align="center" label="ID" prop="id" width="60"></el-table-column>
        <el-table-column align="center" label="分类名称" prop="name"></el-table-column>
        <el-table-column align="center" label="排序" prop="sortOrder" width="80"></el-table-column>
        <el-table-column align="center" label="状态" width="80">
          <template #default="{ row }">
            <span :style="{ color: row.status === 1 ? '#67c23a' : '#f56c6c' }">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="140">
          <template #default="{ row }">
            <span class="editor" @click="openCategoryForm('edit', row)">编辑</span>
            <span class="del" @click="handleCategoryDelete(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分类新增/编辑 内嵌表单 -->
      <div v-if="categoryFormVisible" style="margin-top: 16px; padding: 16px; background: #f9f9f9; border-radius: 4px;">
        <el-form :model="categoryFormData" label-width="80px" size="small">
          <el-form-item label="名称">
            <el-input v-model="categoryFormData.name" placeholder="分类名称"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="categoryFormData.sortOrder" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="categoryFormData.status" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleCategorySubmit" :loading="categorySubmitting">保存</el-button>
            <el-button @click="categoryFormVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'
import ImageCropUpload from '../utils/imageCropUpload.vue'
import RichEditor from '../utils/richEditor.vue'
import globle from '../../globle/globle'

export default {
  components: { ImageCropUpload, RichEditor },
  data() {
    return {
      GLOBAL: globle,
      loading: false,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10,
        categoryId: null,
        status: null,
      },
      // 商品弹窗
      dialogVisible: false,
      dialogMode: 'add',
      submitting: false,
      formData: this.getDefaultForm(),
      formRules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入零售价', trigger: 'blur' }],
      },
      // 分类
      categoryList: [],
      categoryDialogVisible: false,
      categoryLoading: false,
      categoryFormVisible: false,
      categoryFormMode: 'add',
      categorySubmitting: false,
      categoryFormData: { name: '', sortOrder: 0, status: 1 },
    }
  },
  mounted() {
    this.fetchCategories()
    this.fetchList()
  },
  methods: {
    getDefaultForm() {
      return {
        id: null,
        categoryId: null,
        name: '',
        subtitle: '',
        coverImage: '',
        images: '',
        detail: '',
        cityAgentPrice: 0,
        districtAgentPrice: 0,
        dealerPrice: 0,
        retailPrice: 0,
        sortOrder: 0,
        status: 1,
      }
    },
    formatPrice(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    resolveImg(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url
      return (this.globalImgPath || '') + url
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.query.pageNum,
          pageSize: this.query.pageSize,
          categoryId: this.query.categoryId,
          status: this.query.status,
        }
        const res = await axiosconf.applicationJson('/mall/admin/product/list', params)
        if (res.data && res.data.code === 0) {
          const page = res.data.data
          this.tableData = page.records || []
          this.total = page.total || 0
        }
      } catch (e) {
        console.error('获取商品列表失败', e)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.query.pageNum = page
      this.fetchList()
    },
    onFilterChange() {
      this.query.pageNum = 1
      this.fetchList()
    },
    async fetchCategories() {
      this.categoryLoading = true
      try {
        const res = await axiosconf.applicationJson('/mall/admin/product/category/list')
        if (res.data && res.data.code === 0) {
          this.categoryList = res.data.data || []
        }
      } catch (e) {
        console.error('获取分类失败', e)
      } finally {
        this.categoryLoading = false
      }
    },
    openDialog(mode, row) {
      this.dialogMode = mode
      if (mode === 'edit' && row) {
        this.formData = { ...row }
      } else {
        this.formData = this.getDefaultForm()
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.productForm.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          const url = this.dialogMode === 'add'
            ? '/mall/admin/product/add'
            : '/mall/admin/product/edit'
          const res = await axiosconf.applicationJson(url, this.formData)
          if (res.data && res.data.code === 0) {
            this.$message.success(this.dialogMode === 'add' ? '新增成功' : '编辑成功')
            this.dialogVisible = false
            this.fetchList()
          } else {
            this.$message.error(res.data.msg || '操作失败')
          }
        } catch (e) {
          this.$message.error('请求失败')
        } finally {
          this.submitting = false
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该商品？', '提示', { type: 'warning' })
        const res = await axiosconf.applicationJson(`/mall/admin/product/delete/${row.id}`)
        if (res.data && res.data.code === 0) {
          this.$message.success('删除成功')
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      } catch (e) {
        // 用户取消
      }
    },
    // ========== 分类管理 ==========
    openCategoryDialog() {
      this.categoryDialogVisible = true
      this.categoryFormVisible = false
      this.fetchCategories()
    },
    openCategoryForm(mode, row) {
      this.categoryFormMode = mode
      if (mode === 'edit' && row) {
        this.categoryFormData = { ...row }
      } else {
        this.categoryFormData = { name: '', sortOrder: 0, status: 1 }
      }
      this.categoryFormVisible = true
    },
    async handleCategorySubmit() {
      if (!this.categoryFormData.name) {
        this.$message.warning('请输入分类名称')
        return
      }
      this.categorySubmitting = true
      try {
        const url = this.categoryFormMode === 'add'
          ? '/mall/admin/product/category/add'
          : '/mall/admin/product/category/edit'
        const res = await axiosconf.applicationJson(url, this.categoryFormData)
        if (res.data && res.data.code === 0) {
          this.$message.success('保存成功')
          this.categoryFormVisible = false
          this.fetchCategories()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      } finally {
        this.categorySubmitting = false
      }
    },
    async handleCategoryDelete(row) {
      try {
        await this.$confirm('确定删除该分类？', '提示', { type: 'warning' })
        const res = await axiosconf.applicationJson(`/mall/admin/product/category/delete/${row.id}`)
        if (res.data && res.data.code === 0) {
          this.$message.success('删除成功')
          this.fetchCategories()
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      } catch (e) {
        // 用户取消
      }
    },
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.toolbar {
  margin-bottom: 16px;
  overflow: hidden;
}
.addBtn {
  float: right;
  background: #679FF6;
  border-color: #679FF6;
}
.editor {
  color: #679FF6;
  cursor: pointer;
  margin-right: 10px;
}
.del {
  color: #f56c6c;
  cursor: pointer;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>

<style>
.product-edit-dialog .el-dialog__body {
  max-height: calc(90vh - 130px);
  overflow-y: auto;
}
</style>
